webpackJsonp([19],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_lgoinbox_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_router__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "header",
  data: function data() {
    return {
      isLogin: false,
      count: 0,
      notifyCount: 0,
      flag: "",
      profile: {},
      login: false,
      status: false,
      type: "login",
      avatar: "",
      router: __WEBPACK_IMPORTED_MODULE_2__assets_js_router__["a" /* default */]
    };
  },
  components: {
    lgoinbox: __WEBPACK_IMPORTED_MODULE_1_components_lgoinbox_vue__["a" /* default */]
  },
  props: {},
  methods: {
    jsLogin: function jsLogin(type, flag) {
      this.login = flag;
      this.type = type;
    },
    CloseLogin: function CloseLogin(item) {
      this.login = item;
    },
    LoginStatus: function LoginStatus(data) {
      this.status = data;
    },

    getUser: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$http.get("/api/userinfo");

              case 2:
                res = _context.sent;

                if (res.data.mobile) {
                  this.isLogin = true;
                  this.mobile = "****" + res.data.mobile.substr(7, 4);
                  this.local = res.data.local;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUser() {
        return _ref.apply(this, arguments);
      }

      return getUser;
    }(),
    getProfile: function getProfile() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var uid, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                uid = window.localStorage.getItem("uid");

                if (!(uid > 0)) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 4;
                return _this.$http.get("/api/designer/profile", {
                  params: {
                    uid: uid
                  }
                });

              case 4:
                res = _context2.sent;

                _this.avatar = res.data.profile.avatar;
                _this.$store.commit("SET_SOURCECOUNT", res.data.sourceCount);
                _this.$store.commit("SET_AMOUNT", res.data.amount);
                _this.$store.commit("SET_DINGCOUNT", res.data.dingCount);
                _this.$store.commit("SET_FOLLOWERCOUNT", res.data.followerCount);
                _this.$store.commit("SET_PROVINCE", res.data.profile.province);
                _this.$store.commit("SET_CITY", res.data.profile.city);
                _this.$store.commit("SET_DISTRICT", res.data.profile.district);
                _this.$store.commit("SET_BIRTHDAY", res.data.profile.birthday);
                _this.$store.commit("SET_STREET", res.data.profile.street);
                _this.$store.commit("SET_PROFESSION", res.data.profile.profession);
                _this.$store.commit("SET_GENDER", res.data.profile.gender);
                _this.$store.commit("SET_SIGN", res.data.profile.sign);
                _this.$store.commit("SET_CERT", res.data.profile.cert);
                _this.$store.commit("SET_BGIMG", res.data.profile.bgImg);
                _this.$store.commit("SET_NICKNAME", res.data.profile.nickname);
                _this.$store.commit("SET_AVATAR", res.data.profile.avatar);
                _this.$store.commit("SET_DAILY", res.data.profile.daily);
                _this.$store.commit("SET_GOTO", res.data.profile.goto);
                _this.$store.commit("SET_HEIGHT", res.data.profile.height);
                _this.$store.commit("SET_MEMOTY", res.data.profile.memory);
                _this.$store.commit("SET_TOBE", res.data.profile.tobe);
                _this.$store.commit("SET_WISH", res.data.profile.wish);
                _this.$store.commit("SET_FOLLOWINGCOUNT", res.data.followingCount);
                sessionStorage.setItem("store", JSON.stringify(_this.$store.state));
                _context2.next = 33;
                break;

              case 32:
                return _context2.abrupt("return");

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    Layout: function Layout() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$http.get("/api/logout");

              case 2:
                res = _context3.sent;

                if (res.code == 200) {
                  _this2.isLogin = false;
                  window.localStorage.removeItem("uid");
                  window.location.href = "/";
                  window.sessionStorage.removeItem("store");
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    toUploadWorks: function toUploadWorks() {
      if (window.localStorage.getItem("uid")) {
        window.location.href = __WEBPACK_IMPORTED_MODULE_2__assets_js_router__["a" /* default */].upLoadWorks;
      } else {
        this.jsLogin("login", true);
      }
    },
    GetcarCount: function GetcarCount() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!window.localStorage.getItem("uid")) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 3;
                return _this3.$http.get("/api/user/count");

              case 3:
                res = _context4.sent;

                _this3.count = res.data.shoppingCount;
                _this3.notifyCount = res.data.notifyCount;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".navbar-div li").hover(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("em").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children(".dropdown").show();
      }, function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("em").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children(".dropdown").hide();
      });

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".dropdown li a").hover(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("i").show();
      }, function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("i").hide();
      });
    });
    this.isLogin = this.status;
    this.GetcarCount();
    this.getUser();
  },
  watch: {
    status: function status(newValue, oldValue) {
      if (newValue) {
        this.isLogin = newValue;
      }
    }
  },
  created: function created() {
    var _this4 = this;

    this.getProfile();
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", function () {
      sessionStorage.setItem("store", JSON.stringify(_this4.$store.state));
    });
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
      this.avatar = this.$store.state.avatar;
    }
  }
});

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "header",
  data: function data() {
    return {
      signType: "login",
      changeSignType: "mi",
      boxType: "sign",
      backType: "backing",
      Params: {
        mobile: "",
        password: "",
        code: "",
        check: true
      },
      isable: false,
      status: false
    };
  },
  props: {
    Login: Boolean,
    type: String
  },
  methods: {
    smsCode: function smsCode(type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reg, data, res, num, timer, _data, _res, _data2, _res2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(type == "login")) {
                  _context.next = 19;
                  break;
                }

                if (!(_this2.Params.mobile == "")) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", _this2.$message.error("手机号不能为空"));

              case 3:
                reg = /^1[0-9]{10}$/;

                if (reg.test(_this2.Params.mobile)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", _this2.$message.error("手机号格式错误"));

              case 6:
                _this2.isable = true;
                _context.next = 9;
                return _this2.$http.post("/api/mobile/check", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this2.Params.mobile
                }));

              case 9:
                data = _context.sent;

                if (!(data.data == true)) {
                  _context.next = 15;
                  break;
                }

                _this2.isable = false;
                _this2.$message.error("该手机未注册");
                _context.next = 19;
                break;

              case 15:
                _context.next = 17;
                return _this2.$http.post("/api/send/smsCode", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this2.Params.mobile
                }));

              case 17:
                res = _context.sent;

                if (res.code == 200) {
                  _this2.isable = false;
                  _this2.$message.success("验证码已发送");
                  num = 60;
                  timer = setInterval(function () {
                    num--;
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-login-btn").text(num + "s");
                    if (num == 0) {
                      clearInterval(timer);
                      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-login-btn").html("获取验证码");
                    }
                  }, 1000);
                } else {
                  _this2.isable = false;
                  _this2.$message.error(res.msg);
                }

              case 19:
                if (!(type == "register")) {
                  _context.next = 38;
                  break;
                }

                if (!(_this2.Params.mobile == "")) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("return", _this2.$message.error("手机号不能为空"));

              case 22:
                reg = /^1[0-9]{10}$/;

                if (reg.test(_this2.Params.mobile)) {
                  _context.next = 25;
                  break;
                }

                return _context.abrupt("return", _this2.$message.error("手机号格式错误"));

              case 25:
                _this2.isable = true;
                _context.next = 28;
                return _this2.$http.post("/api/mobile/check", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this2.Params.mobile
                }));

              case 28:
                _data = _context.sent;

                if (!(_data.data == false)) {
                  _context.next = 34;
                  break;
                }

                _this2.isable = false;
                _this2.$message.error("该手机已注册");
                _context.next = 38;
                break;

              case 34:
                _context.next = 36;
                return _this2.$http.post("/api/send/smsCode", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this2.Params.mobile,
                  type: type
                }));

              case 36:
                _res = _context.sent;

                if (_res.code == 200) {
                  _this2.isable = false;
                  _this2.$message.success("验证码已发送");
                  num = 60;
                  timer = setInterval(function () {
                    num--;
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-register-btn").text(num + "s");
                    if (num == 0) {
                      clearInterval(timer);
                      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-register-btn").html("获取验证码");
                    }
                  }, 1000);
                } else {
                  _this2.isable = false;
                  _this2.$message.error(_res.msg);
                }

              case 38:
                if (!(type == "back")) {
                  _context.next = 57;
                  break;
                }

                if (!(_this2.Params.mobile == "")) {
                  _context.next = 41;
                  break;
                }

                return _context.abrupt("return", _this2.$message.error("手机号不能为空"));

              case 41:
                reg = /^1[0-9]{10}$/;

                if (reg.test(_this2.Params.mobile)) {
                  _context.next = 44;
                  break;
                }

                return _context.abrupt("return", _this2.$message.error("手机号格式错误"));

              case 44:
                _this2.isable = true;
                _context.next = 47;
                return _this2.$http.post("/api/mobile/check", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this2.Params.mobile
                }));

              case 47:
                _data2 = _context.sent;

                if (!(_data2.data == true)) {
                  _context.next = 53;
                  break;
                }

                _this2.isable = false;
                _this2.$message.error("该手机未注册");
                _context.next = 57;
                break;

              case 53:
                _context.next = 55;
                return _this2.$http.post("/api/send/smsCode", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this2.Params.mobile
                }));

              case 55:
                _res2 = _context.sent;

                if (_res2.code == 200) {
                  _this2.isable = false;
                  _this2.$message.success("验证码已发送");
                  num = 60;
                  timer = setInterval(function () {
                    num--;
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-backpass-btn").text(num + "s");
                    if (num == 0) {
                      clearInterval(timer);
                      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-backpass-btn").html("获取验证码");
                    }
                  }, 1000);
                } else {
                  _this2.isable = false;
                  _this2.$message.error(_res2.msg);
                }

              case 57:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    register: function register() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var reg, res, datainfo, referer_url;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.Params.mobile == "")) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", _this3.$message.error("手机号不能为空"));

              case 2:
                reg = /^1[0-9]{10}$/;

                if (reg.test(_this3.Params.mobile)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", _this3.$message.error("手机号格式错误"));

              case 5:
                if (!(_this3.Params.password == "")) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", _this3.$message.error("密码不能为空"));

              case 7:
                if (!(_this3.Params.code == "")) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", _this3.$message.error("验证码不能为空"));

              case 9:
                if (!(_this3.Params.check == false)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", _this3.$message.error("请勾选用户协议"));

              case 11:
                _this3.isable = true;
                _context2.next = 14;
                return _this3.$http.post("/api/register", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  account: _this3.Params.mobile,
                  password: _this3.Params.password,
                  code: _this3.Params.code
                }));

              case 14:
                res = _context2.sent;

                if (!(res.code == 200)) {
                  _context2.next = 29;
                  break;
                }

                _this3.isable = false;
                _context2.next = 19;
                return _this3.$http.get("/api/userinfo");

              case 19:
                datainfo = _context2.sent;

                if (datainfo.data.mobile) {
                  window.localStorage.setItem("uid", datainfo.data.uid);
                  _this3.status = true;
                }
                referer_url = localStorage.getItem("referer_url");

                if (referer_url) {
                  localStorage.removeItem("referer_url");
                  location.href = referer_url;
                }
                _this3.$emit("CloseLogin", false);
                _this3.$emit("LoginStatus", _this3.status);
                _this3.$message.success("注册成功");
                _this3.$emit("getinfo");
                _context2.next = 31;
                break;

              case 29:
                _this3.isable = false;
                _this3.$message.error(res.msg);

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    login: function login(type) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var reg, res, data, datainfo, _res3, _data3, _datainfo;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(type == "mi")) {
                  _context3.next = 34;
                  break;
                }

                if (!(_this4.Params.mobile == "")) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", _this4.$message.error("手机号不能为空"));

              case 3:
                reg = /^1[0-9]{10}$/;

                if (reg.test(_this4.Params.mobile)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", _this4.$message.error("手机号格式错误"));

              case 6:
                if (!(_this4.Params.password == "")) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", _this4.$message.error("密码不能为空"));

              case 8:
                _this4.isable = true;
                _context3.next = 11;
                return _this4.$http.post("/api/mobile/check", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this4.Params.mobile
                }));

              case 11:
                res = _context3.sent;

                if (!(res.data == true)) {
                  _context3.next = 17;
                  break;
                }

                _this4.isable = false;
                _this4.$message.error("该手机未注册");
                _context3.next = 34;
                break;

              case 17:
                _context3.next = 19;
                return _this4.$http.post("/api/login", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  account: _this4.Params.mobile,
                  password: _this4.Params.password
                }));

              case 19:
                data = _context3.sent;

                if (!(data.code == 200)) {
                  _context3.next = 32;
                  break;
                }

                _this4.isable = false;
                _context3.next = 24;
                return _this4.$http.get("/api/userinfo");

              case 24:
                datainfo = _context3.sent;

                if (datainfo.data.mobile) {
                  window.localStorage.setItem("uid", datainfo.data.uid);
                  _this4.status = true;
                }
                _this4.$emit("CloseLogin", false);
                _this4.$emit("LoginStatus", _this4.status);
                _this4.$message.success("登入成功");
                _this4.$emit("getinfo");
                _context3.next = 34;
                break;

              case 32:
                _this4.isable = false;
                _this4.$message.error(data.msg);

              case 34:
                if (!(type == "yan")) {
                  _context3.next = 68;
                  break;
                }

                if (!(_this4.Params.mobile == "")) {
                  _context3.next = 37;
                  break;
                }

                return _context3.abrupt("return", _this4.$message.error("手机号不能为空"));

              case 37:
                reg = /^1[0-9]{10}$/;

                if (reg.test(_this4.Params.mobile)) {
                  _context3.next = 40;
                  break;
                }

                return _context3.abrupt("return", _this4.$message.error("手机号格式错误"));

              case 40:
                if (!(_this4.Params.code == "")) {
                  _context3.next = 42;
                  break;
                }

                return _context3.abrupt("return", _this4.$message.error("验证码不能为空"));

              case 42:
                _this4.isable = true;
                _context3.next = 45;
                return _this4.$http.post("/api/mobile/check", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this4.Params.mobile
                }));

              case 45:
                _res3 = _context3.sent;

                if (!(_res3.data == true)) {
                  _context3.next = 51;
                  break;
                }

                _this4.isable = false;
                _this4.$message.error("该手机未注册");
                _context3.next = 68;
                break;

              case 51:
                _context3.next = 53;
                return _this4.$http.post("/api/login", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  mobile: _this4.Params.mobile,
                  code: _this4.Params.code
                }));

              case 53:
                _data3 = _context3.sent;

                if (!(_data3.code == 200)) {
                  _context3.next = 66;
                  break;
                }

                _this4.isable = false;
                _context3.next = 58;
                return _this4.$http.get("/api/userinfo");

              case 58:
                _datainfo = _context3.sent;

                if (_datainfo.data.mobile) {
                  window.localStorage.setItem("uid", _datainfo.data.uid);
                  _this4.status = true;
                }
                _this4.$emit("CloseLogin", false);
                _this4.$emit("LoginStatus", _this4.status);
                _this4.$message.success("登入成功");
                _this4.$emit("getinfo");
                _context3.next = 68;
                break;

              case 66:
                _this4.isable = false;
                _this4.$message.error(_data3.msg);

              case 68:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    passwordReset: function passwordReset() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.$http.post("/api/passwordreset", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                  account: _this5.Params.mobile,
                  password: _this5.Params.password,
                  code: _this5.Params.code
                }));

              case 2:
                res = _context4.sent;

                if (res.code == 200) {
                  _this5.Params.mobile = "";
                  _this5.Params.password = "";
                  _this5.Params.code = "";
                  _this5.backType = "backsuccess";
                } else {
                  _this5.$message.error(res.msg);
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    backPassword: function backPassword() {
      this.Params.mobile = "";
      this.Params.password = "";
      this.Params.code = "";
      this.boxType = "back";
    },
    signTypeClick: function signTypeClick() {
      this.Params.mobile = "";
      this.Params.password = "";
      this.Params.code = "";
      this.changeSignType = "mi";
    },
    Tologin: function Tologin() {
      this.Params.mobile = "";
      this.Params.password = "";
      this.Params.code = "";
      this.signType = "login";
      this.changeSignType = "mi";
      this.boxType = "sign";
    },
    ToThird: function ToThird(type) {
      window.location.href = "/api/oauth?type=" + type;
    }
  },
  watch: {
    Login: function Login(newValue, oldValue) {
      this.Login = newValue;
      if (newValue) {
        this.Params.mobile = "";
        this.Params.password = "";
        this.Params.code = "";
        this.signType = "login";
        this.changeSignType = "mi";
        this.boxType = "sign";
      }
    },
    type: function type(newValue, oldValue) {
      if (newValue) {
        this.signType = newValue;
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      var _this = _this6;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).keyup(function (event) {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".parent-box").css("display") == "block") {
          if (event.keyCode == 13) {
            if (_this.signType == "login") {
              if (_this.changeSignType == "mi") {
                _this.login("mi");
              } else {
                _this.login("yan");
              }
            } else {
              _this.register();
            }
          }
        }
      });
    });
  },
  created: function created() {}
});

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_plugin_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_globel_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_globel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_globel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_iconfont_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_util_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_util_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_util_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_animate_min_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_globle_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_globle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_area_data_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_area_data_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_area_data_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_area_linkage_vue_dist_index_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_area_linkage_vue_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_area_linkage_vue_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_area_linkage_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_area_linkage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_area_linkage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_cropper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_cropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_cropper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_waterfall2__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_waterfall2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_waterfall2__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











// import info from "../assets/js/info";










__WEBPACK_IMPORTED_MODULE_2_es6_promise___default.a.polyfill();

__WEBPACK_IMPORTED_MODULE_16_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_16_axios___default.a.defaults.baseURL = "";

// axios.defaults.headers.common['Cookie'] = 'ULT=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJkYXRhIjoiMSIsImlzcyI6InNoYXBpLmNsb3RoZXNtYWtlLmNvbS5jbiIsImF1ZCI6InNoYXBpLmNsb3RoZXNtYWtlLmNvbS5jbiIsImlhdCI6MTU4NzM4NzUyMywiZXhwIjoxNjQ3ODY3NTIzfQ.kvDc6vPT0di5QEUmpqFePvCwz1Ev8I3LTsFkBwJA1W4Rln2zvVx2tnRefenP0Jdjp_GB_WmaxGboMapCurbyusddaxmYWsrD-OOAJ5A-ctfu-3bcmTlfi9GrTTnQF6IvY_KOToKI05uD2MNRdZGqPoh6hnljFmncG8xK_zkwB4o;';
__WEBPACK_IMPORTED_MODULE_16_axios___default.a.interceptors.response.use(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = res.data.code;
            _context.next = _context.t0 === 1001 ? 3 : _context.t0 === 200 ? 6 : 7;
            break;

          case 3:
            __WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].prototype.$message.error(res.data.msg);
            window.location.href = "/login.html";
            return _context.abrupt("return", Promise.reject(res));

          case 6:
            return _context.abrupt("return", res.data);

          case 7:
            if (!(res.data.code > 0)) {
              _context.next = 10;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].prototype.$message.error(res.data.msg);
            return _context.abrupt("return", Promise.reject(res));

          case 10:
            return _context.abrupt("return", res);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = "请求错误(400)";
        break;
      case 401:
        err.message = "未授权，请重新登录(401)";
        break;
      case 403:
        err.message = "您没有权限访问此页面";
        break;
      case 404:
        err.message = "请求出错(404)";
        break;
      case 408:
        err.message = "请求超时(408)";
        break;
      case 500:
        err.message = "服务器错误(500)";
        break;
      case 501:
        err.message = "服务未实现(501)";
        break;
      case 502:
        err.message = "网络错误(502)";
        break;
      case 503:
        err.message = "服务不可用(503)";
        break;
      case 504:
        err.message = "网络超时(504)";
        break;
      case 505:
        err.message = "HTTP版本不受支持(505)";
        break;
      default:
        err.message = "连接出错!";
    }
  } else {
    err.message = "连接服务器失败!";
  }

  __WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].prototype.$message.error(err.message);

  return Promise.reject(err);
});

__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].config.productionTip = false;
// Vue.prototype.$info = info;
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].prototype.$store = __WEBPACK_IMPORTED_MODULE_17__store_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_waterfall2___default.a);
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_16_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_area_linkage_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_cropper___default.a);
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].prototype.$pcaa = __WEBPACK_IMPORTED_MODULE_12_area_data_vue__["pcaa"];
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].directive("throttle", {
  inserted: function inserted(el, binding) {
    el.addEventListener("click", function () {
      el.style.pointerEvents = "none";
      if (!el.disabled) {
        setTimeout(function () {
          el.style.pointerEvents = "auto";
        }, binding.value || 2000);
      }
    });
  }
});

Object.keys(__WEBPACK_IMPORTED_MODULE_10__assets_globle__["d" /* default */]).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_10__assets_globle__["d" /* default */][key]);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_Vue__["a" /* default */]);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/material-img.fd6548d.png";

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);

// 按需求引入组件


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Button"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["ButtonGroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Form"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["FormItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Input"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Container"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Header"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Aside"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Main"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Menu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MenuItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MenuItemGroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Submenu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["BreadcrumbItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Card"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Table"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["TableColumn"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Switch"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Pagination"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Row"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Col"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Dialog"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Tag"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Tree"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Option"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Cascader"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Alert"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["TabPane"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Steps"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Step"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["CheckboxGroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Checkbox"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Upload"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Radio"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["RadioGroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Image"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Link"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["RadioButton"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Calendar"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Popover"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["DropdownItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["DropdownMenu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Dropdown"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Message"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"].confirm;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uploadUrl */
/* unused harmony export sourceUrl */
/* harmony export (immutable) */ __webpack_exports__["e"] = getInfoByUrl;
/* unused harmony export date */
/* harmony export (immutable) */ __webpack_exports__["b"] = acTiveArrStringFun;
/* harmony export (immutable) */ __webpack_exports__["a"] = Imgsuffix;
/* unused harmony export processUrl */
/* harmony export (immutable) */ __webpack_exports__["c"] = backUrl;
/* unused harmony export formatDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


function uploadUrl(url) {
  if (url == "") return "";

  var imgurl = "https://dingzhi-prod.oss-cn-hangzhou.aliyuncs.com";

  return imgurl + "/" + url;
}

function sourceUrl(url) {
  if (url == "") return "";

  var sourceUrl = "https://cm-source.oss-cn-hangzhou.aliyuncs.com";

  return sourceUrl + "/" + url;
}

// url截取
function getInfoByUrl(url) {
  var urlinfo = {};
  var search = url.split("?");
  if (search.length > 1) {
    var searchpara = search.pop();
    var paras = searchpara.split("&");
    var urlParas = [];
    for (var i = 0, l = paras.length; i < l; i++) {
      var item = paras[i].split("=");
      if (item.length > 1) {
        urlParas.push({
          Key: item[0],
          Value: decodeURI(item[1])
        });
        urlinfo[item[0]] = decodeURI(item[1]);
      }
    }
  }
  return urlinfo;
}
// 时间格式化
function date(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  if (time == 0) return "-";

  if ((time + "").length === 10) {
    time = +time * 1000;
  }

  var format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  var date = new Date();
  if ((typeof time === "undefined" ? "undefined" : _typeof(time)) === "object") {
    date = time;
  } else {
    date = new Date(parseInt(time + ""));
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };

  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === "a") return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  }
  // (result, key) => {

  // }
  );
  return time_str;
}

function acTiveArrStringFun(obj) {
  var arr = [];
  if (obj != null && obj.length !== 0) {
    for (var i = 0; i < obj.length; i++) {
      arr.push(obj[i]);
    }
  }
  return arr.toString();
}

function Imgsuffix(img) {
  var suffix = img.split("/");
  var Imagesuffix = suffix[1];
  if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(Imagesuffix)) {
    return Imagesuffix;
  }
}

function processUrl() {
  if (false) {
    return 'http://cmali.com';
  } else {
    return '';
  }
}

function backUrl() {
  if (false) {
    return 'http://cm.cn';
  } else {
    return 'https://www.clothesmake.com.cn';
  }
}
/**
 * @desc 格式化日期字符串
 * @param { Nubmer} - 时间戳
 * @returns { String } 格式化后的日期字符串
 */
function formatDate(timestamp) {
  // 补全为13位
  var arrTimestamp = (timestamp + '').split('');
  for (var start = 0; start < 13; start++) {
    if (!arrTimestamp[start]) {
      arrTimestamp[start] = '0';
    }
  }
  timestamp = arrTimestamp.join('') * 1;
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var month = day * 30;
  var now = new Date().getTime();
  var diffValue = now - timestamp;
  // 如果本地时间反而小于变量时间
  if (diffValue < 0) {
    return '不久前';
  }
  // 计算差异时间的量级
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  // 数值补0方法
  var zero = function zero(value) {
    if (value < 10) {
      return '0' + value;
    }
    return value;
  };
  // 使用
  if (monthC > 4) {
    // 超过1年，直接显示年月日
    return function () {
      var date = new Date(timestamp);
      return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日';
    }();
  } else if (monthC >= 1) {
    return parseInt(monthC) + '月前';
  } else if (weekC >= 1) {
    return parseInt(weekC) + '周前';
  } else if (dayC >= 1) {
    return parseInt(dayC) + '天前';
  } else if (hourC >= 1) {
    return parseInt(hourC) + '小时前';
  } else if (minC >= 1) {
    return parseInt(minC) + '分钟前';
  }
  return '刚刚';
}

var filters = {
  uploadUrl: uploadUrl,
  getInfoByUrl: getInfoByUrl,
  date: date,
  formatDate: formatDate,
  sourceUrl: sourceUrl,
  processUrl: processUrl,
  backUrl: backUrl
};

/* harmony default export */ __webpack_exports__["d"] = (filters);

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vueWaterfall",staticClass:"vue-waterfall",class:_vm.isTransition&&'is-transition',style:({height:_vm.height}),attrs:{"id":"vueWaterfall"}},[_c('div',{staticClass:"slot-box"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lgoinbox_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5ca65e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lgoinbox_vue__ = __webpack_require__(36);
function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a5ca65e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lgoinbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5ca65e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lgoinbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gongzhonghao-img.11d336f.png";

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/weibo-img.b84f858.png";

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottom_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e329cd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_vue__ = __webpack_require__(30);
function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e329cd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e329cd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 29:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer display-flex"},[_c('div',{staticClass:"footer-serve-div m-r-150"},[_c('h3',[_vm._v("服务")]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("电子礼品卡")])]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("企业团购")])]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("订阅电子邮箱")])]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("网站反馈")])])]),_vm._v(" "),_c('div',{staticClass:"footer-help-div m-r-149"},[_c('h3',[_vm._v("获得帮助")]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("订单状态")])]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("配送方式")])]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("退换货")])]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("付款方式")])]),_vm._v(" "),_c('dd',[_c('a',{attrs:{"href":"#"}},[_vm._v("联系我们")])])]),_vm._v(" "),_c('div',{staticClass:"footer-us-div"},[_c('h3',[_vm._v("关注我们")]),_vm._v(" "),_c('div',{staticClass:"footer-img-div display-flex m-t-3"},[_c('div',{staticClass:"footer-us-public"},[_c('img',{staticClass:"m-b-16",attrs:{"src":__webpack_require__(26)}}),_vm._v(" "),_c('p',[_vm._v("公众号")])]),_vm._v(" "),_c('div',{staticClass:"footer-us-weibo m-l-28"},[_c('img',{staticClass:"m-b-16",attrs:{"src":__webpack_require__(27)}}),_vm._v(" "),_c('p',[_vm._v("新浪微博")])])])])]),_vm._v(" "),_c('div',{staticClass:"beian",staticStyle:{"text-align":"center"}},[_c('p',[_vm._v("\n      ©2016-2020 www.alidingzhi.com All Rights Reserved.     杭州持码网络科技有限公司 版权所有  \n      "),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn"}},[_vm._v("浙ICP备16043117号-2")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avatar-empty.e29a460.png";

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAAKlBMVEX1piP1piT1qCj2rzj3vFv3vVz4vFv5zID60o/97dL979f++fD//fv///93aZctAAAAeklEQVQY02O4CwQrnJVMukAMBiCeygACkRDecQEwj7EGxLudwAABbHuBvGMMMJAD5BXAeex3GW4KwHmMcxmuMiBALMMCJB4XQwMSj4PBAYnHwmCAxGNmUEDiMaHxUFWimoJqA6rtqC5DdTWqj9B8ixoSqKGEFoJIoQsABblB4cDTFwgAAAAASUVORK5CYII="

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f987b82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(37);
function injectStyle (ssrContext) {
  __webpack_require__(34)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f987b82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f987b82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 34:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.Login),expression:"Login"}],staticClass:"parent-box"},[_c('div',{staticClass:"parent-shadow",on:{"click":function($event){return _vm.$emit('CloseLogin', false)}}}),_vm._v(" "),_c('div',{staticClass:"parent animate__animated animate__fadeInRight"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.boxType == 'sign'),expression:"boxType == 'sign'"}],staticClass:"sign"},[_c('div',{staticClass:"from-head"},[_c('div',{staticClass:"login"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signType),expression:"signType"}],attrs:{"type":"radio","id":"login","value":"login","hidden":""},domProps:{"checked":_vm._q(_vm.signType,"login")},on:{"change":function($event){_vm.signType="login"}}}),_vm._v(" "),_c('label',{class:_vm.signType=='login'?'current': '',attrs:{"for":"login"},on:{"click":_vm.signTypeClick}},[_vm._v("登录")])]),_vm._v(" "),_c('div',{staticClass:"resgiter"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signType),expression:"signType"}],attrs:{"type":"radio","id":"resgiter","value":"resgiter","hidden":""},domProps:{"checked":_vm._q(_vm.signType,"resgiter")},on:{"change":function($event){_vm.signType="resgiter"}}}),_vm._v(" "),_c('label',{class:_vm.signType=='resgiter' ?'current':'',attrs:{"for":"resgiter"},on:{"click":_vm.signTypeClick}},[_vm._v("注册")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signType=='login'),expression:"signType=='login'"}],attrs:{"id":"cm-login-from"}},[_c('div',{staticClass:"form-group tel-div m-t-47"},[_c('i',{staticClass:"mobile-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.mobile),expression:"Params.mobile"}],attrs:{"type":"text","id":"login-mobile","name":"mobile","placeholder":"手机号"},domProps:{"value":(_vm.Params.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "mobile", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"login-mobile-error"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeSignType=='mi'),expression:"changeSignType=='mi'"}],staticClass:"form-group m-t-30 js-login-mi-div"},[_c('i',{staticClass:"password-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.password),expression:"Params.password"}],attrs:{"type":"password","id":"login-password","name":"pass","placeholder":"密码"},domProps:{"value":(_vm.Params.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"login-password-error"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeSignType=='yan'),expression:"changeSignType=='yan'"}],staticClass:"form-group capity-div m-t-30 js-login-yan-div"},[_c('a',{staticClass:"btn-login-verify js-login-btn-verify"},[_c('button',{staticClass:"btn js-login-btn",attrs:{"type":"button","disabled":_vm.isable},on:{"click":function($event){return _vm.smsCode('login')}}},[_vm._v("发送验证码")])]),_vm._v(" "),_c('i',{staticClass:"capity-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.code),expression:"Params.code"}],attrs:{"type":"text","id":"login-capity","name":"capity","placeholder":"验证码"},domProps:{"value":(_vm.Params.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "code", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"login-capity-error"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeSignType=='mi'),expression:"changeSignType=='mi'"}],staticClass:"form-checkbox form-group m-t-30"},[_c('input',{attrs:{"type":"checkbox","id":"login-checked","name":"agree","checked":""}}),_vm._v(" "),_c('label',{staticClass:"checked login-cecked",attrs:{"for":"login-checked"}}),_vm._v(" "),_c('a',{staticClass:"checked-text1"},[_vm._v("记住我")]),_vm._v(" "),_c('a',{staticClass:"js-backpass checked-text2",on:{"click":_vm.backPassword}},[_vm._v("忘记密码?")])]),_vm._v(" "),_c('div',{staticClass:"form-change",class:_vm.changeSignType=='mi' ? 'm-t-23' : 'm-t-80'},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeSignType=='mi'),expression:"changeSignType=='mi'"}],staticClass:"js-change-yan"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.changeSignType),expression:"changeSignType"}],attrs:{"type":"radio","id":"change-yan","hidden":"","value":"yan"},domProps:{"checked":_vm._q(_vm.changeSignType,"yan")},on:{"change":function($event){_vm.changeSignType="yan"}}}),_vm._v(" "),_c('label',{attrs:{"for":"change-yan"},on:{"click":_vm.signTypeClick}},[_vm._v("验证码登录")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeSignType=='yan'),expression:"changeSignType=='yan'"}],staticClass:"js-change-mi"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.changeSignType),expression:"changeSignType"}],attrs:{"type":"radio","hidden":"","id":"change-mi","value":"mi"},domProps:{"checked":_vm._q(_vm.changeSignType,"mi")},on:{"change":function($event){_vm.changeSignType="mi"}}}),_vm._v(" "),_c('label',{attrs:{"for":"change-mi"},on:{"click":_vm.signTypeClick}},[_vm._v("密码登录")])])]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeSignType=='mi'),expression:"changeSignType=='mi'"}],staticClass:"cm-register-btn login-btn-div js-login-mi m-t-28",attrs:{"type":"button"},on:{"click":function($event){return _vm.login('mi')}}},[_vm._v("登录")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeSignType=='yan'),expression:"changeSignType=='yan'"}],staticClass:"cm-register-btn login-btn-div js-login-yan m-t-28",attrs:{"type":"button"},on:{"click":function($event){return _vm.login('yan')}}},[_vm._v("登录")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-third-sign m-t-37"},[_c('p',[_vm._v("第三方账号登录")]),_vm._v(" "),_c('div',{staticClass:"btn-sign-icon m-t-22"},[_c('a',{staticClass:"weixin-icon",on:{"click":function($event){return _vm.ToThird('wx')}}}),_vm._v(" "),_c('a',{staticClass:"weibo-icon",on:{"click":function($event){return _vm.ToThird('weibo')}}}),_vm._v(" "),_c('a',{staticClass:"qq-icon",on:{"click":function($event){return _vm.ToThird('qq')}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signType=='resgiter'),expression:"signType=='resgiter'"}],staticClass:"item",attrs:{"id":"cm-register-from"}},[_c('div',{staticClass:"form-group tel-div m-t-47"},[_c('i',{staticClass:"mobile-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.mobile),expression:"Params.mobile"}],attrs:{"type":"text","id":"register-mobile","name":"mobile","placeholder":"手机号"},domProps:{"value":(_vm.Params.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "mobile", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"register-mobile-error"}})]),_vm._v(" "),_c('div',{staticClass:"form-group m-t-30"},[_c('i',{staticClass:"password-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.password),expression:"Params.password"}],attrs:{"type":"password","id":"register-password","name":"pass","placeholder":"密码"},domProps:{"value":(_vm.Params.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"register-password-error"}})]),_vm._v(" "),_c('div',{staticClass:"form-group capity-div m-t-30"},[_c('a',{staticClass:"btn-register-verify js-register-btn-verify"},[_c('button',{staticClass:"btn js-register-btn",attrs:{"type":"button","disabled":_vm.isable},on:{"click":function($event){return _vm.smsCode('register')}}},[_vm._v("发送验证码")])]),_vm._v(" "),_c('i',{staticClass:"capity-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.code),expression:"Params.code"}],attrs:{"type":"text","id":"register-capity","name":"capity","placeholder":"验证码"},domProps:{"value":(_vm.Params.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "code", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"register-capity-error"}})]),_vm._v(" "),_c('div',{staticClass:"form-checkbox m-t-42"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.check),expression:"Params.check"}],attrs:{"type":"checkbox","id":"register-checked","name":"agree"},domProps:{"checked":Array.isArray(_vm.Params.check)?_vm._i(_vm.Params.check,null)>-1:(_vm.Params.check)},on:{"change":function($event){var $$a=_vm.Params.check,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.Params, "check", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.Params, "check", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.Params, "check", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"checked resgiter-checked",attrs:{"for":"register-checked"}}),_vm._v("\n          我已阅读并接受\n          "),_c('a',{staticClass:"common-color"},[_vm._v("用户协议")]),_vm._v("和\n          "),_c('a',{staticClass:"common-color"},[_vm._v("隐私政策")])]),_vm._v(" "),_c('button',{staticClass:"cm-register-btn resgiter-btn-div js-reigster m-t-28",attrs:{"disabled":_vm.isable},on:{"click":_vm.register}},[_vm._v("注册")]),_vm._v(" "),_c('div',{staticClass:"to-sign m-t-28"},[_c('label',[_vm._v("\n            已有账号，去\n            "),_c('a',{staticClass:"common-color js-go-login",on:{"click":_vm.Tologin}},[_vm._v("登录")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-third-sign m-t-28"},[_c('p',[_vm._v("第三方账号登录")]),_vm._v(" "),_c('div',{staticClass:"btn-sign-icon m-t-22"},[_c('a',{staticClass:"weixin-icon",on:{"click":function($event){return _vm.ToThird('wx')}}}),_vm._v(" "),_c('a',{staticClass:"weibo-icon",on:{"click":function($event){return _vm.ToThird('weibo')}}}),_vm._v(" "),_c('a',{staticClass:"qq-icon",on:{"click":function($event){return _vm.ToThird('qq')}}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.boxType == 'back'),expression:"boxType == 'back'"}],staticClass:"backpass-div"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backType == 'backing'),expression:"backType == 'backing'"}],staticClass:"backpass-head"},[_c('div',{staticClass:"js-backpass-text"},[_vm._v("找回密码")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backType == 'backing'),expression:"backType == 'backing'"}],staticClass:"backpass",attrs:{"id":"cm-backpass-from"}},[_c('div',{staticClass:"form-group tel-div m-t-47"},[_c('i',{staticClass:"mobile-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.mobile),expression:"Params.mobile"}],attrs:{"type":"text","id":"backpass-mobile","name":"mobile","placeholder":"手机号"},domProps:{"value":(_vm.Params.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "mobile", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"backpass-mobile-error"}})]),_vm._v(" "),_c('div',{staticClass:"form-group m-t-30"},[_c('i',{staticClass:"password-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.password),expression:"Params.password"}],attrs:{"type":"password","id":"set-password","name":"pass","placeholder":"设置密码"},domProps:{"value":(_vm.Params.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"set-password-error"}})]),_vm._v(" "),_c('div',{staticClass:"form-group capity-div m-t-30"},[_c('a',{staticClass:"btn-backpass-verify js-backpass-btn-verify"},[_c('button',{staticClass:"btn js-backpass-btn",attrs:{"type":"button","disabled":_vm.isable},on:{"click":function($event){return _vm.smsCode('back')}}},[_vm._v("发送验证码")])]),_vm._v(" "),_c('i',{staticClass:"capity-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Params.code),expression:"Params.code"}],attrs:{"type":"text","id":"backpass-capity","name":"capity","placeholder":"验证码"},domProps:{"value":(_vm.Params.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Params, "code", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"msg",attrs:{"id":"backpass-capity-error"}})]),_vm._v(" "),_c('button',{staticClass:"cm-register-btn backpass-btn-div js-backpass-next m-t-28",attrs:{"type":"button"},on:{"click":_vm.passwordReset}},[_vm._v("确认修改")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backType == 'backsuccess'),expression:"backType == 'backsuccess'"}],staticClass:"reset-success-div"},[_c('div',{staticClass:"success-div"}),_vm._v(" "),_c('p',{staticClass:"m-t-54"},[_vm._v("您已成功修改密码，请使用新密码登录")]),_vm._v(" "),_c('button',{staticClass:"cm-register-btn js-to-login m-t-36",attrs:{"type":"button"},on:{"click":_vm.Tologin}},[_vm._v("去登录")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-text resgiter-text m-t-50"},[_c('label',[_vm._v("开启你的定制之旅！")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-text resgiter-text m-t-37"},[_c('label',[_vm._v("开启你的定制之旅！")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_bottom_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_header_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_css_swiper_css__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_swiper_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_globle_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: {
    headerd: __WEBPACK_IMPORTED_MODULE_1_components_common_header_vue__["a" /* default */],
    bottom: __WEBPACK_IMPORTED_MODULE_0_components_common_bottom_vue__["a" /* default */],
    Swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["Swiper"],
    SwiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["SwiperSlide"]
  },
  directives: {
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["directive"]
  },
  data: function data() {
    return {
      serachName: "",
      tag: "",
      auther: [],
      swiperoptinon: {
        slidesPerView: 3,
        spaceBetween: 30
        // grabCursor: true
      },
      autherId: "",
      total: 0,
      Queryinfo: {
        type: 10,
        // 当前的页码
        pagenum: 1,
        // 每页显示几条数据
        pagesize: 12
      },
      autherShow: false
    };
  },
  mounted: function mounted() {},

  methods: {
    onKeyup: function onKeyup() {
      this.key = this.serachName;
      this.getDesignerList();
    },
    getDesignerList: function getDesignerList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$http.get("/api/designer/list", {
                  params: {
                    key: _this.key,
                    page: _this.Queryinfo.pagenum,
                    limit: 12
                  }
                });

              case 2:
                res = _context.sent;

                res.data.designers.forEach(function (item) {
                  if (item.birthday != null) {
                    var birthday = item.birthday.split("-")[0];
                    var cloneBirthday = birthday.slice(2, 3);
                    item.birthday = cloneBirthday + '0后';
                  }
                });
                _this.auther = res.data.designers;
                if (_this.auther.length == 0) {
                  _this.autherShow = false;
                } else {
                  _this.autherShow = true;
                }
                _this.total = res.data.paginator.count;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toCertification: function toCertification() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_6__assets_js_router__["a" /* default */].certIfication;
    },
    sourceDetail: function sourceDetail(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.open(__WEBPACK_IMPORTED_MODULE_6__assets_js_router__["a" /* default */].opusDetail + "?id=" + id);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    desginerDetail: function desginerDetail(id) {
      window.location.href = __WEBPACK_IMPORTED_MODULE_6__assets_js_router__["a" /* default */].desginerInfo + "?uid=" + id;
    },
    cancleFollow: function cancleFollow(uid) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$http.post("/api/designer/unfollow", __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({
                  uid: uid
                }));

              case 2:
                res = _context3.sent;

                _this3.getDesignerList();
                _this3.$message.success("已取消关注");

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    follow: function follow(uid) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$http.post("/api/designer/follow", __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({
                  uid: uid
                }));

              case 2:
                res = _context4.sent;

                _this4.getDesignerList();
                _this4.$message.success("关注成功");

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },

    // 分页 监听 pagenum 改变
    handleCurrentChange: function handleCurrentChange(newnum) {
      this.Queryinfo.pagenum = newnum;
      this.getDesignerList();
    }
  },
  created: function created() {
    this.getDesignerList();
  },
  beforeCreate: function beforeCreate() {}
});

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('div',{staticClass:"header-cont display-flex ban"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar-div display-flex m-l-100"},[_c('li',{staticClass:"navbar-li"},[_c('a',{staticClass:"navbar-a",attrs:{"href":"#"}},[_vm._v("T恤定制")]),_vm._v(" "),_c('em'),_vm._v(" "),_c('ul',{staticClass:"dropdown"},[_c('li',[_c('a',{attrs:{"href":_vm.router.custom + '?ssid=4'}},[_c('i'),_vm._v("40支双纱经典款 ")])])])]),_vm._v(" "),_c('li',{staticClass:"navbar-li"},[_c('a',{staticClass:"navbar-a",attrs:{"href":"#"}},[_vm._v("探索")]),_vm._v(" "),_c('em'),_vm._v(" "),_c('ul',{staticClass:"dropdown"},[_c('li',[_c('a',{attrs:{"href":_vm.router.desginer}},[_c('i'),_vm._v("设计师 ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.router.opus}},[_c('i'),_vm._v("素材区 ")])])])]),_vm._v(" "),_c('li',{staticClass:"navbar-li"}),_vm._v(" "),_c('li',{staticClass:"navbar-li"}),_vm._v(" "),_c('li',{staticClass:"navbar-li"})]),_vm._v(" "),_c('div',{staticClass:"header-icon-div"},[_c('li',{staticClass:"header-upload"},[_c('a',{staticClass:"js-to-uploadworks",on:{"click":_vm.toUploadWorks}},[_c('i',{staticClass:"header-upload-icon"}),_vm._v(" "),_c('span',{staticClass:"header-span"},[_vm._v("上传")])])]),_vm._v(" "),_c('li',{staticClass:"header-serach"},[_c('a',{attrs:{"href":_vm.router.car}},[_c('i',{staticClass:"header-serach-icon"},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.count > 0),expression:"count > 0"}],staticClass:"js-car-count"},[_vm._v(_vm._s(_vm.count))])]),_vm._v(" "),_c('span',{staticClass:"header-span"},[_vm._v("购物车")])])]),_vm._v(" "),_c('li',{staticClass:"header-mess"},[_c('a',{attrs:{"href":_vm.router.myMessage}},[_c('i',{staticClass:"header-mess-icon"},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.notifyCount > 0),expression:"notifyCount > 0"}]},[_vm._v(_vm._s(_vm.notifyCount))])]),_vm._v(" "),_c('span',{staticClass:"header-span"},[_vm._v("消息")])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLogin),expression:"isLogin"}],staticClass:"header-car"},[_c('a',{staticClass:"header-layout-icon js-layout-menu"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.avatar),expression:"avatar"}],attrs:{"src":_vm.avatar,"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.avatar),expression:"!avatar"}],attrs:{"src":__webpack_require__(32),"alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"LoginDown"},[_c('li',[_c('a',{attrs:{"href":_vm.router.userOpus}},[_vm._v("我的作品")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.router.userOrder}},[_vm._v("我的订单")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.router.userAdress}},[_vm._v("收货地址")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.router.editUserInfo}},[_vm._v("修改资料")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":_vm.Layout}},[_vm._v("退出登录")])])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLogin),expression:"!isLogin"}],staticClass:"header-shape"},[_c('a',{staticStyle:{"display":"inline-blcok"}},[_c('i',{staticClass:"header-shape-icon"}),_vm._v(" "),_c('span',{staticClass:"header-span"},[_c('a',{staticClass:"js-login-menu",on:{"click":function($event){return _vm.jsLogin('login', true)}}},[_vm._v("登录")]),_vm._v("/\n              "),_c('a',{staticClass:"js-register-menu",on:{"click":function($event){return _vm.jsLogin('resgiter', true)}}},[_vm._v("注册")])])])]),_vm._v(" "),_c('li',{staticClass:"header-layout"},[_c('a',{attrs:{"href":_vm.router.treaty + '?type=PROCOTOL'}},[_c('i',{staticClass:"header-menu-icon"}),_vm._v(" "),_c('span',{staticClass:"header-span"},[_vm._v("用户协议")])])])])])]),_vm._v(" "),_c('lgoinbox',{attrs:{"Login":_vm.login,"type":_vm.type},on:{"CloseLogin":_vm.CloseLogin,"getinfo":_vm.getProfile,"LoginStatus":_vm.LoginStatus}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-div"},[_c('h1',[_c('a',{attrs:{"href":"/","title":"CM"}},[_vm._v("CM")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var router = {
    custom: '/custom.html',
    userOpus: '/useropus.html',
    certIfication: '/certification.html',
    editUserInfo: '/edituserinfo.html',
    upLoadWorks: '/uploadworks.html',
    userDing: '/userding.html',
    opusDetail: '/opusdetail.html',
    // begindesign : '/begindesign.html',
    userOrder: '/userorder.html',
    userAdress: '/useradress.html',
    userIncome: '/userincome.html',
    userInfo: '/userinfo.html',
    orderDetail: '/orderdetail.html',
    myMessage: '/mymessage.html',
    car: '/car.html',
    login: '/login.html',
    register: '/register.html',
    binDing: '/binding.html',
    order: '/order.html',
    pay: '/pay.html',
    opus: '/opus.html',
    desginer: '/desginer.html',
    accountSelf: '/accountself.html',
    desginerInfo: '/desginerinfo.html',
    touchCustom: '/touchCustom.html',
    touchCar: '/touchCar.html',
    treaty: '/treaty.html'
};

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bus__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

global.regeneratorRuntime = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		col: {
			type: Number,
			default: 2
		},
		width: Number,
		height: {
			type: String
			// default:'100vh',    取消height默认值
		},
		data: {
			type: Array,
			default: []
		},
		gutterWidth: {
			type: Number,
			default: 10
		},
		isTransition: {
			type: Boolean,
			default: true
		},
		lazyDistance: {
			type: Number,
			default: 300
		},
		loadDistance: {
			type: Number,
			default: 300
		}

	},
	data: function data() {
		return {
			root: null,
			columns: [],
			loadmore: true,
			timeout: null,
			lazyTimeout: null,
			lastScrollTop: 0,
			timer: null,
			loadedIndex: 0,
			columnWidth: 0,
			isresizing: false,
			clientHeight: document.documentElement.clientHeight || document.body.clientHeight,
			clientWidth: document.documentElement.clientWidth || document.body.clientWidth
		};
	},

	computed: {
		trueLazyDistance: function trueLazyDistance() {
			return this.clientWidth / 375 * this.lazyDistance;
		},
		max: function max() {
			return this.clientWidth / 375 * this.loadDistance;
		}
	},
	watch: {
		col: function col(val) {
			var _this = this;

			this.$nextTick(function () {
				setTimeout(function () {
					_this.init();
				}, 300);
			});
		},
		data: function data(newVal, oldVal) {
			var _this2 = this;

			this.$nextTick(function () {
				clearTimeout(_this2.timer);
				_this2.timer = setTimeout(function () {
					if (_this2.isresizing) {
						return;
					}
					if (newVal.length < _this2.loadedIndex) {
						_this2.loadedIndex = 0;
					}
					if (newVal.length > oldVal.length || newVal.length > _this2.loadedIndex) {
						if (newVal.length === oldVal.length) {
							_this2.resize(_this2.loadedIndex > 0 ? _this2.loadedIndex : null);
							return;
						}
						_this2.resize(oldVal.length > 0 ? oldVal.length : null);
					}
				}, 300);
			});
		}
	},
	methods: {
		init: function init() {
			//initialize
			this.root = this.$refs.vueWaterfall;
			this.clearColumn();
			var col = parseInt(this.col);
			for (var i = 0; i < col; i++) {
				var odiv = document.createElement('div');
				odiv.className = 'vue-waterfall-column';
				if (this.width) {
					odiv.style.width = this.width + 'px';
					if (i != 0) {
						odiv.style.marginLeft = this.gutterWidth + 'px';
					}
					this.columnWidth = this.width;
				} else {
					odiv.style.width = 100 / parseInt(col) + '%';
					this.columnWidth = 100 / parseInt(col) / 100 * document.documentElement.clientWidth;
				}
				if (!this.root) {
					this.root = this.$refs.vueWaterfall;
				}
				this.root && this.root.appendChild(odiv);
				this.columns.push(odiv);
			}
			this.resize();
		},
		setDomImageHeight: function setDomImageHeight(dom) {
			var _this3 = this;

			return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var imgs, i, lazySrc, newImg, trueWidth, imgColumnHeight;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (dom.getElementByTagName) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								imgs = dom.getElementByTagName('img');
								i = 0;

							case 4:
								if (!(i < imgs.length)) {
									_context.next = 20;
									break;
								}

								lazySrc = imgs[i].getAttribute('lazy-src');

								if (!(!imgs[i].getAttribute('src') && lazySrc)) {
									_context.next = 17;
									break;
								}

								newImg = new Image();

								newImg.src = lazySrc;

								if (!newImg.complete) {
									_context.next = 15;
									break;
								}

								trueWidth = imgs[i].offsetWidth || _this3.columnWidth;
								imgColumnHeight = newImg.height * trueWidth / newImg.width;


								if (imgs[i].offsetWidth) {
									imgs[i].style.height = imgColumnHeight + 'px';
								}
								_context.next = 17;
								break;

							case 15:
								_context.next = 17;
								return new Promise(function (resolve, reject) {
									newImg.onload = function () {
										var trueWidth = imgs[i].offsetWidth || this.columnWidth;
										var imgColumnHeight = newImg.height * trueWidth / newImg.width;

										if (imgs[i].offsetWidth) {
											imgs[i].style.height = imgColumnHeight + 'px';
										}
										resolve();
									};
									newImg.onerror = function () {
										resolve();
									};
								});

							case 17:
								i++;
								_context.next = 4;
								break;

							case 20:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3);
			}))();
		},
		append: function append(dom) {
			var _this4 = this;

			return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
				var self, min, i;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								//append dom element

								self = _this4;

								if (!(_this4.columns.length > 0)) {
									_context2.next = 19;
									break;
								}

								min = _this4.columns[0];
								i = 1;

							case 4:
								if (!(i < _this4.columns.length)) {
									_context2.next = 16;
									break;
								}

								_context2.next = 7;
								return self.getHeight(min);

							case 7:
								_context2.t0 = _context2.sent;
								_context2.next = 10;
								return self.getHeight(self.columns[i]);

							case 10:
								_context2.t1 = _context2.sent;

								if (!(_context2.t0 > _context2.t1)) {
									_context2.next = 13;
									break;
								}

								min = self.columns[i];

							case 13:
								i++;
								_context2.next = 4;
								break;

							case 16:
								min && min.appendChild(dom);
								_context2.next = 19;
								return _this4.setDomImageHeight(dom);

							case 19:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this4);
			}))();
		},
		checkImg: function checkImg(dom) {
			//check has image
			if (!dom) {
				return false;
			}
			if (dom.getElementsByTagName && dom.getElementsByTagName("img").length) {
				return true;
			} else {
				return false;
			}
		},
		resize: function resize(index, elements) {
			var _this5 = this;

			return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
				var self, j, imgs, newImg;
				return regeneratorRuntime.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								//resize and render
								_this5.isresizing = true;
								self = _this5;

								if (_this5.$slots.default) {
									_context5.next = 5;
									break;
								}

								_this5.isresizing = false;
								return _context5.abrupt('return');

							case 5:
								if (!index && index != 0 && !elements) {
									elements = _this5.$slots.default;
									_this5.loadedIndex = 0;
									_this5.clear();
								} else if (!elements) {
									_this5.loadedIndex = index;
									elements = _this5.$slots.default.splice(index);
								}

								j = 0;

							case 7:
								if (!(j < elements.length)) {
									_context5.next = 28;
									break;
								}

								if (!(elements[j].elm && self.checkImg(elements[j].elm))) {
									_context5.next = 22;
									break;
								}

								imgs = elements[j].elm.getElementsByTagName('img');
								newImg = new Image();

								newImg.src = imgs[0].src;

								if (!newImg.complete) {
									_context5.next = 18;
									break;
								}

								_context5.next = 15;
								return self.append(elements[j].elm);

							case 15:
								self.lazyLoad(imgs);
								_context5.next = 20;
								break;

							case 18:
								_context5.next = 20;
								return new Promise(function (resolve, reject) {
									newImg.onload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
										return regeneratorRuntime.wrap(function _callee3$(_context3) {
											while (1) {
												switch (_context3.prev = _context3.next) {
													case 0:
														_context3.next = 2;
														return self.append(elements[j].elm);

													case 2:
														self.lazyLoad(imgs);
														resolve();

													case 4:
													case 'end':
														return _context3.stop();
												}
											}
										}, _callee3, this);
									}));
									newImg.onerror = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
										return regeneratorRuntime.wrap(function _callee4$(_context4) {
											while (1) {
												switch (_context4.prev = _context4.next) {
													case 0:
														_context4.next = 2;
														return self.append(elements[j].elm);

													case 2:
														self.lazyLoad(imgs);
														resolve();

													case 4:
													case 'end':
														return _context4.stop();
												}
											}
										}, _callee4, this);
									}));
								});

							case 20:
								_context5.next = 24;
								break;

							case 22:
								_context5.next = 24;
								return self.append(elements[j].elm);

							case 24:
								self.loadedIndex++;

							case 25:
								j++;
								_context5.next = 7;
								break;

							case 28:
								_this5.isresizing = false;
								self.$emit('finish');

							case 30:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		computedPx: function computedPx(img, imgApi) {

			img.style.width = imgApi.width / this.columnWidth;
		},
		lazyLoad: function lazyLoad(imgs) {
			if (!imgs) {
				if (!this.root) {
					this.root = this.$refs.vueWaterfall;
				}
				imgs = this.root && this.root.getElementsByTagName('img');
			}

			if (!imgs || imgs.length < 0) {
				return;
			}
			for (var index = 0; index < imgs.length; index++) {
				if (imgs[index].className.match('animation') && imgs[index].getAttribute('src')) {
					continue;
				} else if (imgs[index].className.match('animation') && !imgs[index].getAttribute('src')) {
					imgs[index].src = imgs[index].getAttribute('lazy-src');
					imgs[index].removeAttribute('lazy-src');
				} else if (imgs[index].getAttribute('src') && !imgs[index].className.match('animation')) {
					imgs[index].className = imgs[index].className + ' animation';
				} else if (!imgs[index].getAttribute('src') && imgs[index].getBoundingClientRect().top < this.clientHeight + this.trueLazyDistance) {
					imgs[index].src = imgs[index].getAttribute('lazy-src');
					imgs[index].className = imgs[index].className + ' animation';
					imgs[index].removeAttribute('lazy-src');
				}
			}
		},
		clearColumn: function clearColumn() {
			this.columns.forEach(function (item) {
				item.remove();
			});
			this.columns = [];
		},
		clear: function clear() {
			this.columns.forEach(function (item) {
				item.innerHTML = '';
			});
		},
		mix: function mix() {
			var elements = this.$slots.default;
			elements.sort(function () {
				return Math.random() - 0.5;
			});
			this.resize(0, elements);
		},
		getHeight: function getHeight(dom) {
			var _this6 = this;

			return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
				return regeneratorRuntime.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								return _context6.abrupt('return', dom.offsetHeight);

							case 1:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		emitLoadMore: function emitLoadMore() {
			if (!this.root) {
				return;
			}
			var self = this;
			var scrollTop = this.height ? this.root.scrollTop : document.documentElement.scrollTop || document.body.scrollTop;
			var scrollHeight = this.height ? this.root.scrollHeight : document.documentElement.offsetHeight;
			var diff = scrollHeight - scrollTop - self.clientHeight;
			self.$emit('scroll', { scrollHeight: scrollHeight, scrollTop: scrollTop, clientHeight: self.clientHeight, diff: diff, time: Date.now() });
			if (diff < self.max && self.loadmore && scrollHeight > self.clientHeight) {
				self.lastScrollTop = scrollTop;
				self.loadmore = false;
				self.$emit('loadmore');
			} else if (diff >= self.max) {
				self.loadmore = true;
			}
			clearTimeout(self.lazyTimeout);
			self.lazyTimeout = setTimeout(function () {
				self.lazyLoad();
			}, 14);
		}
	},
	destroyed: function destroyed() {
		this.root && (this.root.onscroll = null);
		this.root && (this.root.onresize = null);
		window.onscroll = null;
		window.onresize = null;
	},
	beforeCreate: function beforeCreate() {
		var _this7 = this;

		__WEBPACK_IMPORTED_MODULE_0__bus___default.a.$on('forceUpdate', function () {
			_this7.resize();
		});
		__WEBPACK_IMPORTED_MODULE_0__bus___default.a.$on('mix', function () {
			_this7.mix();
		});
	},
	mounted: function mounted() {
		var _this8 = this;

		this.$nextTick(function () {
			_this8.init();
			var self = _this8;
			if (_this8.height) {
				_this8.root.onscroll = function (e) {
					self.emitLoadMore();
				};
				_this8.root.addEventListener('touchmove', function () {
					self.emitLoadMore();
				});
			} else {
				window.onscroll = function (e) {
					self.emitLoadMore();
				};
				document.addEventListener('touchmove', function () {
					self.emitLoadMore();
				});
			}
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38)))

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waterfall_vue__ = __webpack_require__(5);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03c760e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_waterfall_vue__ = __webpack_require__(24);
function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waterfall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03c760e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_waterfall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(49);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    sourceCount: 0,
    amount: 0,
    dingCount: 0,
    followerCount: 0,
    followingCount: 0,
    province: "",
    city: "",
    district: "",
    street: "",
    birthday: "",
    profession: "",
    gender: "",
    sign: "",
    bgImg: "",
    cert: "",
    nickname: "",
    avatar: "",
    daily: "",
    goto: "",
    height: "",
    memory: "",
    tobe: "",
    wish: ""
  },
  mutations: {
    SET_SOURCECOUNT: function SET_SOURCECOUNT(state, data) {
      state.sourceCount = data;
    },
    SET_AMOUNT: function SET_AMOUNT(state, data) {
      state.amount = data;
    },
    SET_DINGCOUNT: function SET_DINGCOUNT(state, data) {
      state.dingCount = data;
    },
    SET_FOLLOWERCOUNT: function SET_FOLLOWERCOUNT(state, data) {
      state.followerCount = data;
    },
    SET_FOLLOWINGCOUNT: function SET_FOLLOWINGCOUNT(state, data) {
      state.followingCount = data;
    },
    SET_PROVINCE: function SET_PROVINCE(state, data) {
      state.province = data;
    },
    SET_CITY: function SET_CITY(state, data) {
      state.city = data;
    },
    SET_DISTRICT: function SET_DISTRICT(state, data) {
      state.district = data;
    },
    SET_BIRTHDAY: function SET_BIRTHDAY(state, data) {
      state.birthday = data;
    },
    SET_STREET: function SET_STREET(state, data) {
      state.street = data;
    },
    SET_PROFESSION: function SET_PROFESSION(state, data) {
      state.profession = data;
    },
    SET_GENDER: function SET_GENDER(state, data) {
      state.gender = data;
    },
    SET_SIGN: function SET_SIGN(state, data) {
      state.sign = data;
    },
    SET_CERT: function SET_CERT(state, data) {
      state.cert = data;
    },
    SET_BGIMG: function SET_BGIMG(state, data) {
      state.bgImg = data;
    },
    SET_NICKNAME: function SET_NICKNAME(state, data) {
      state.nickname = data;
    },
    SET_AVATAR: function SET_AVATAR(state, data) {
      state.avatar = data;
    },
    SET_DAILY: function SET_DAILY(state, data) {
      state.daily = data;
    },
    SET_GOTO: function SET_GOTO(state, data) {
      state.goto = data;
    },
    SET_HEIGHT: function SET_HEIGHT(state, data) {
      state.height = data;
    },
    SET_MEMOTY: function SET_MEMOTY(state, data) {
      state.memory = data;
    },
    SET_TOBE: function SET_TOBE(state, data) {
      state.tobe = data;
    },
    SET_WISH: function SET_WISH(state, data) {
      state.wish = data;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "cell",
  data: function data() {
    return {
      msg: "我是多页面 的 cell  页面"
    };
  }
});

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(13);
module.exports = __webpack_require__(917);


/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__desginer_vue__ = __webpack_require__(918);




new __WEBPACK_IMPORTED_MODULE_1__index_js__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__desginer_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_desginer_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da515ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_desginer_vue__ = __webpack_require__(924);
function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5da515ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_desginer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da515ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_desginer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 919:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('headerd'),_vm._v(" "),_c('div',[_c('div',{staticClass:"material-head"},[_c('img',{attrs:{"src":__webpack_require__(162),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"material-shadow"}),_vm._v(" "),_c('div',{staticClass:"material-div"},[_c('p',[_vm._v("设计师招募进行中")]),_vm._v(" "),_c('button',{on:{"click":_vm.toCertification}},[_vm._v("立即申请")])])]),_vm._v(" "),_c('div',{staticClass:"materialp-div ban"},[_c('div',{staticClass:"materialp-search"},[_c('i'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serachName),expression:"serachName"}],attrs:{"type":"text","placeholder":"搜索设计师、插画、动漫…"},domProps:{"value":(_vm.serachName)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onKeyup($event)},"input":function($event){if($event.target.composing){ return; }_vm.serachName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"design"},[_vm._l((_vm.auther),function(item,index){return _c('div',{key:index,staticClass:"partent-box"},[_c('div',{staticClass:"opus-box"},[_c('div',{staticClass:"author"},[_c('div',{staticClass:"author-portrait",on:{"click":function($event){return _vm.desginerDetail(item.id)}}},[(item.avatar)?_c('img',{attrs:{"src":item.avatar,"alt":""}}):_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"author-flower"})]),_vm._v(" "),_c('div',{staticClass:"author-info"},[_c('p',{staticClass:"info"},[_c('em',[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('span',[(item.gender == 'male')?_c('i',{staticClass:"male"}):_vm._e(),_vm._v(" "),(item.gender == 'famale')?_c('i',{staticClass:"famale"}):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item.birthday != null),expression:"item.birthday != null"}]},[_vm._v(_vm._s(item.birthday))])])]),_vm._v(" "),_c('p',{staticClass:"local"},[_vm._v(_vm._s(item.city))]),_vm._v(" "),_c('p',{staticClass:"descrip"},[_vm._v(_vm._s(item.sign))]),_vm._v(" "),_c('p',{staticClass:"fans"},[_c('span',[_vm._v("\n                  作品\n                  "),_c('em',[_vm._v(_vm._s(item.sourceCount))])]),_vm._v(" "),_c('span',[_vm._v("\n                  关注者\n                  "),_c('em',[_vm._v(_vm._s(item.followerCount))])])]),_vm._v(" "),(item.isfollow)?_c('button',{staticClass:"follow-btn un-follow",on:{"click":function($event){return _vm.cancleFollow(item.id)}}},[_vm._v("已关注")]):_vm._e(),_vm._v(" "),(!item.isfollow)?_c('button',{staticClass:"follow-btn follow",on:{"click":function($event){return _vm.follow(item.id)}}},[_vm._v("关注")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"author-opus"},_vm._l((item.sources.slice(0,3)),function(item1,index1){return _c('li',{key:index1},[_c('a',{on:{"click":function($event){return _vm.sourceDetail(item1.id)}}},[_c('img',{attrs:{"src":item1.url,"alt":""}})])])}),0)]),_vm._v(" "),_c('p',{staticClass:"more"},[_c('a',{on:{"click":function($event){return _vm.desginerDetail(item.id)}}},[_vm._v("\n              查看更多\n              "),_c('i',{staticClass:"more-icon"})])])])}),_vm._v(" "),_c('el-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.autherShow),expression:"autherShow"}],staticClass:"page",attrs:{"current-page":_vm.Queryinfo.pagenum,"page-sizes":[12],"page-size":_vm.Queryinfo.pagesize,"layout":"pager","total":_vm.total,"font-size":"18px !important"},on:{"current-change":_vm.handleCurrentChange}})],2)])]),_vm._v(" "),_c('bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[916]);


// WEBPACK FOOTER //
// static/js/desginer.8e1ac5f90e67fcf4b812.js